<template>
  <TotalText :x="x" :y="y" :color="color">{{ isTotal ? 'Total' : serie }}</TotalText>
</template>

<script>
import { TotalText } from './areaChart.styles';

export default {
  components: { TotalText },
  props: {
    lastItem: Object,
    parentWidth: Number,
    yScale: Function,
    serie: String,
    color: String,
    isTotal: Boolean,
  },
  computed: {
    x() {
      return this.parentWidth - 20;
    },
    y() {
      return this.yScale(this.lastItem[this.serie]) - 5;
    },
  },
};
</script>
